// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"8143aade","311":"b4b7dc1e","569":"ecdeecfe"}[chunkId] + ".chunk.js";
};